import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Company } from 'app/models';
import { CompanyService } from 'app/services';

@Component({
  standalone: false,
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss']
})
export class CompanyInfoComponent implements OnChanges {
  @Input() company: Company;
  @Input() companyInitials: string;
  @Input() currentProfile = { internal: false };
  displayAddress: string;

  constructor( public companyService: CompanyService) {}


  ngOnChanges(changes: SimpleChanges) {
    if (changes.company.currentValue) {
      this.displayAddress = `${this.company.address}, ${this.company.city}, ${this.company.state}, 
                            ${this.company.country}, ${this.company.postalCode}. `;
    }
  }

}
